import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { RequirementStatusOption } from '../models/requirement.model';

export interface CountByStatusResponse {
  status: string;
  count: number;
}

@Injectable({ providedIn: 'root' })
export class RequirementStatusService {
  private http = inject(HttpClient);
  private base = `${environment.apiBaseUrl}/api/v1/projects`;

  list(projectId: string): Observable<RequirementStatusOption[]> {
    return this.http.get<RequirementStatusOption[]>(`${this.base}/${projectId}/requirement-statuses`);
  }

  countByStatus(projectId: string, status: string): Observable<CountByStatusResponse> {
    const params = new HttpParams().set('status', status);
    return this.http.get<CountByStatusResponse>(`${this.base}/${projectId}/requirements/count-by-status`, { params });
  }

  reorder(projectId: string, orderedIds: string[]): Observable<void> {
    return this.http.patch<void>(`${this.base}/${projectId}/requirement-statuses/reorder`, { orderedIds });
  }
}
